import { Injectable } from '@angular/core';

import { Timestamp, arrayUnion, collection, doc, setDoc, count, sum, average, getAggregateFromServer, getFirestore, deleteDoc, getDocs, where, query, documentId, getDoc, updateDoc, getDocFromCache, addDoc, orderBy, increment } from "firebase/firestore";
import moment from 'moment';
import { BehaviorSubject, Observable, defer, from, switchMap } from 'rxjs';
import { ownedCollection, withCurrentOwner } from '../../../utils/firestore-ownership';


@Injectable({
  providedIn: 'root'
})
export class StocksService {

  private stocks!: BehaviorSubject<any[]>;

  constructor() {
    this.stocks = new BehaviorSubject<any[]>([])
  }

  public async selectAll(): Promise<void> {
    // console.log('StocksService', 'selectAll')

    const stocks:any[] = []

    const q = ownedCollection('Stocks');
    const allDocs = await getDocs(q)
    allDocs.docs.forEach((d:any, j:any, h:any) => {
      // console.log('Doc:', d.id, 'Side:', d.data().side, j, h)
      
      const doc = { ...d.data(), id: d.id }
      stocks.push(doc)
    })
    
    this.stocks.next(stocks)
  }

  getAll(): Observable<any[]> {
    console.log('CompaniesService', 'getAll')

    return defer(() => from(this.selectAll()).pipe(switchMap(() => this.stocks.asObservable())));
  }

  async addItem(e:any):Promise<void> {
    console.log('StocksService', 'addItem', e)

    if(e.amount != undefined)
      e.amount = e.amount.toString()

    // if(e.date != undefined)
    //   e.date = new Date(e.date.seconds).getSeconds()

    await addDoc(collection(getFirestore(), 'Stocks'), { ...withCurrentOwner(e), created_on: Timestamp.now(), modified_on: Timestamp.now() });

    // this.stocks.next([e, ...this.stocks.value])
    await this.selectAll()
  }

  async delete(e:any):Promise<void>{
    console.log('StocksService', 'delete', e.id)

    await deleteDoc(doc(getFirestore(), 'Stocks', e.id));
    await this.selectAll();
  }

  async modify(e:any):Promise<void>{
    console.log('StocksService', 'modify', e.id)

    await updateDoc(doc(getFirestore(), 'Stocks', e.id), { ...withCurrentOwner(e), modified_on: Timestamp.now() });
    await this.selectAll();
  }

  async updateAttach(e: any, path: string, name: string):Promise<void> {
    console.log('StocksService', 'updateAttach', e.id)
    
    await updateDoc(doc(getFirestore(), "Stocks", e.id), {
      attach: increment(1),
      attachments: arrayUnion({ path, name, createdOn: Timestamp.now() })
    })
    .then(() => {
      console.log('StocksService', 'updateAttach', e.id, 'UPDATED')
    })    
  }

}
